import Vue from "vue";
import icons from "./icons";
import {get} from "lodash";

Vue.mixin({
	methods: {
		icon(icon) {
			return get(icons, icon);
		}
	}
});
